import { GetLeadByFiltersType } from "../components/customwidgets/leads-tracking-report/types";
import { ChangeAlertCallbackType } from "../components/Root";

import * as API from '../http/api';
import { getPosition } from "./PositionService";

export type FilterCountLeadService = {
    status?: string[],
    type?: string[]
}
export type LeadType = "PM" | "PFAE"

export type CountLeadType = {
    status?: string,
    type?: string,
    name?: string,
    count: number
}

export type ResponseCountLead = {
    data: {
        content: {
            details: CountLeadType[]
        },
        response: string
    }

}

export type OnboardingSectionLead = {
    lead_uuid: string,
    section_name: string,
}

export class LeadService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    private async getLeadCount({ status, type }: FilterCountLeadService): Promise<ResponseCountLead> {
        const data = {
            operation: "getCountLeadByStatus",
            data: {
                ...(status && { status: [...status] }),
                ...(type && { type: [...type] })
            }
        };
        const pos = getPosition();
        const response = await API.service('leadsTrackingReport', data, pos, this.changeAlert, null, null);
        return response?.data
    }

    async getLeadCountByStatus(status: string[]): Promise<ResponseCountLead> {
        return this.getLeadCount({ status })
    }
    async getLeadCountByType(type: string[]): Promise<ResponseCountLead> {
        return this.getLeadCount({ type })
    }
    async getLeadsByFilters(filters: GetLeadByFiltersType) {
        const data = {
            operation: "getLeadsByFilters",
            data: {
                ...filters
            }
        };
        const pos = getPosition();
        const response = await API.service('leadsTrackingReport', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async updateStatus(lead: {
        lead_uuid: string,
        new_status: string,
        customer_uuid: string
    }) {
        const data = {
            operation: "updateStatusLead",
            data: {
                ...lead
            }
        };
        const pos = getPosition();
        const response = await API.service('updateStatusLead', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async getOnboardingSectionLead(filters: OnboardingSectionLead) {
        const data = {
            operation: "getOnboardingSectionLead",
            data: {
                ...filters
            }
        };
        const pos = getPosition();
        const response = await API.service('getOnboardingSectionLead', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async calculateRiskLevel(lead: {
        leadUuid: string,
    }) {
        const data = {
            operation: "calculateRiskLevel",
            data: {
                ...lead
            }
        };
        const pos = getPosition();
        const response = await API.service('calculateRiskLevel', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async getSectionStatusLead(data) {
        const pos = getPosition();
        const response = await API.service('getSectionStatusLead', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async updateSectionStatusLead(data) {
        const pos = getPosition();
        const response = await API.service('updateSectionStatusLead', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async getCompanyRecord(data) {
        const pos = getPosition();
        const response = await API.service('getCompanyRecord', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async createAfbCustomer(data) {
        const pos = getPosition();
        const response = await API.service('createAfbCustomer', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async pldManualCheck(data) {
        const pos = getPosition();
        const response = await API.service('pldManualCheck', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async pldRetry(data) {
        const pos = getPosition();
        const response = await API.service('pldRetry', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async startBlacklistValidation(data) {
        const pos = getPosition();
        const response = await API.service('startBlacklistValidation', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
}

